import * as React from 'react';
import { Link } from 'react-router-dom';
const classNames = require('classnames');

import { IconArrowRight } from '../components/icons';

interface Props {
	className?: string;
	title?: string;
	value?: number | string;
	subValue?: number | string;
	to?: string;
	linkLabel?: string;
}

class AdminHomePageCell extends React.Component<Props, any> {
	render() {
		const { className, title, value, subValue, to, linkLabel } = this.props;
		return (
			<div className={classNames('dashboard-cell admin-dashboard-cell', className)}>
				{title && <div className="admin-dashboard-cell-title">{title}</div>}
				<div className="admin-dashboard-cell-value">{value !== undefined ? value : '-'}</div>
				{subValue && (
					<div className="admin-dashboard-cell-subvalue">
						<em>{subValue}</em>
					</div>
				)}
				{to && (
					<Link to={to} className="admin-dashboard-cell-link arrow-link">
						<span className="arrow-link-content">
							<span className="arrow-link-label">{linkLabel}</span>
							<IconArrowRight className="arrow-link-icon" />
						</span>
					</Link>
				)}
			</div>
		);
	}
}

export default AdminHomePageCell;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/AdminHomePageCell.tsx